import type { NormalizedPushSubscription, RawPushSubscription } from '../../state/types';

export const normalizePushSubscriptions = (rawSubscriptions: RawPushSubscription[]): NormalizedPushSubscription[] =>
  rawSubscriptions.map(({ clientId, endpoint, applicationServerKeyHash }) => ({
    clientId,
    endpoint,
    applicationServerKeyHash,
  }));
